/**
 * Route for `self-signup-manual-approval-for-advertiser-accounts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SelfSignupManualApprovalForAdvertiserAccountsPage } from "../features/self-signup-manual-approval-for-advertiser-accounts/SelfSignupManualApprovalForAdvertiserAccountsPage";

export const selfSignupManualApprovalForAdvertiserAccountsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/self-signup-manual-approval-for-advertiser-accounts",
	component: SelfSignupManualApprovalForAdvertiserAccountsPage,
});

export default selfSignupManualApprovalForAdvertiserAccountsRoute;
